export default function trimEmail (email, length = 25) {
  if (email.indexOf('@') === -1 || email.length <= length) {
    return email;
  }

  const [username, domain] = email.split('@');

  return `${username.slice(0, username.length - Math.min(username.length - 5, length))}…@${domain}`;
}
